import { useRouter } from "next/router";
import { IProductsSearchCriteria } from "./types";
import { decodeProductsSearchCriteria } from "./utils";

export const useProductsSearchCriteriaByURL = (): IProductsSearchCriteria => {
  const {
    query: { criteria },
  } = useRouter();

  if (criteria) {
    return decodeProductsSearchCriteria(String(criteria));
  }

  return {};
};
